import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useGeneral = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const goToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };
  return {
    navigate,
    loading,
    setLoading,
    goToTop
  };
};

export default useGeneral;
